module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"readMore":"Voir plus"},"en":{"readMore":"Read more"},"es":{"readMore":"Ver más"},"it":{"readMore":"Mostra tutto"},"de":{"readMore":"Mehr"},"nl":{"readMore":"Meer weergeven"},"pt":{"readMore":"Read more"}}')
  delete Component.options._Ctor
}
